var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('v-wait',{attrs:{"for":"request_to_complete"}},[_c('template',{slot:"waiting"},[_c('LoaderComponent')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }